// COMPONENTS
import AdvancedQuery from "../../components/advancedQuery/advancedQuery.component";

const Page = () => {
  return (
    <div className="mr-2 w-full flex flex-col items-center px-4 overflow-y-scroll">
      <h1>Advanced Query</h1>
      <AdvancedQuery />
    </div>
  );
};

export default Page;
